import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { headerStore } from 'apps/components/header/app';
import { observer } from 'mobx-react';

import {
  SearchWrapper,
  SearchButton,
  SearchInput,
  SearchForm,
} from './search.styled';

const Search = observer(props => {
  const { searchWrapperStyle, searchFormStyle, searchInputStyle } = props;
  const { searchTerm, searchIsVisible } = headerStore;

  const ref = useRef(null);

  const onSubmitSearch = event => {
    event.preventDefault();
    if (searchTerm === '') {
      headerStore?.HideSearch();
    } else {
      headerStore?.NavigateToSearchPage();
    }
  };

  const onClickSearch = () => {
    if (searchIsVisible) {
      headerStore?.HideSearch();
      ref?.current?.blur();
    } else {
      headerStore?.ShowSearch();
      ref?.current?.focus();
    }
  };

  const onKeyDownSearch = event => {
    if (event.key === 'Escape') {
      if (searchTerm !== '') {
        headerStore?.ResetSearchTerm();
      } else {
        headerStore?.HideSearch();
      }
    }
  };

  return (
    <SearchWrapper
      style={searchWrapperStyle}
      isMobile={props.isMobile}
      searchIsVisible={searchIsVisible}
    >
      <SearchForm
        onSubmit={onSubmitSearch}
        inverted={props.inverted}
        variant={props.variant}
        style={searchFormStyle}
      >
        <SearchButton
          outline
          variant='tertiary'
          icon='search'
          active={props.active}
          ariaLabel='Search'
          name='search-button'
          isDark={props.isDark}
          size={props.size || searchIsVisible ? 'small' : 'default'}
          onClick={onClickSearch}
        />
        <SearchInput
          name='search-input'
          type='text'
          ref={ref}
          style={searchInputStyle}
          value={searchTerm}
          inverted={props.inverted}
          variant={props.variant}
          placeholder={props.t('Search Community...')}
          onBlur={() => {
            if (searchTerm === '') headerStore?.HideSearch();
          }}
          onKeyDown={onKeyDownSearch}
          onChange={event => headerStore?.UpdateSearchTerm(event.target.value)}
        />
      </SearchForm>
    </SearchWrapper>
  );
});

Search.defaultProps = {
  isMobile: false,
  isDark: false,
  searchTerm: '',
  variant: 'default',
};

Search.propTypes = {
  variant: PropTypes.string,
  inverted: PropTypes.bool,
  isMobile: PropTypes.bool,
  isDark: PropTypes.bool,
  t: PropTypes.func,
  searchTerm: PropTypes.string,
  searchWrapperStyle: PropTypes.object,
  searchFormStyle: PropTypes.object,
  searchInputStyle: PropTypes.object,
};

export default withNamespaces()(Search);
